import React from 'react';
import { CheckCircle } from 'lucide-react';

export function WhoIWorkWith() {
  const clinicTypes = [
    'Osteopathy and manual therapy clinics',
    'Physiotherapy and chiropractic clinics',
    'Massage therapy and bodywork',
    'Med spas and aesthetic clinics',
    'Other health practitioners who book clients by appointment'
  ];

  return (
    <div className="py-10 bg-black/40">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Who Priority AI Services is for
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Priority AI Services is built for hands-on clinic owners who are in the treatment room most of the day and don't have time to babysit their marketing or chase every lead.
          </p>
        </div>

        <div className="bg-gray-900/50 backdrop-blur-sm border border-blue-500/20 rounded-lg p-8">
          <ul className="space-y-4">
            {clinicTypes.map((type, index) => (
              <li key={index} className="flex items-start gap-4">
                <CheckCircle className="w-6 h-6 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-lg text-gray-300">{type}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
